import React, { useEffect } from 'react';
import { useGlobalContext } from "../context/GlobalContext";

export const Dev = () => {
  const { setLightTheme } = useGlobalContext()

  useEffect(() => {
    setLightTheme(true)
  }, [])

  const blocks = (
    <div className="b-dev l-container">
      <div className="b-dev__container">
          <a className="b-dev__cover" href="https://www.theydo.io/" target="_blank" rel="noopener noreferrer">
            <img className="lazyload b-dev__cover-image" src={require('../static/images/menu_covers/theydo_cover.png')} alt="theydo" />
          </a>
        <div className="b-dev__content">
          <h4 className="b-dev__title">TheyDo</h4>
          <p>Customer centric tool for a real-time collaborative journey mapping.</p>
          <p>Fullstack TypeScript. Built in Vue.js, Node.js and GraphQL.</p>
          <br />
          <a className="b-dev__link" href="https://www.theydo.io/" target="_blank" rel="noopener noreferrer"><p>></p> Visit TheyDo.</a>
        </div>
      </div>
      <div className="b-dev__container">
        <a className="b-dev__cover" href="https://www.airmiles.nl/miles-en-me/" target="_blank" rel="noopener noreferrer">
        <img className="lazyload b-dev__cover-image" src={require('../static/images/menu_covers/airmiles_cover.png')} alt="airmiles" />
        </a>
        <div className="b-dev__content">
        <h4 className="b-dev__title">Miles & Me</h4>
          <p>Onboarding flow for collaborative loyalty program of Airmiles and Shell by Dept.</p>
          <p>Built with Nunjucks, a JavaScript templating engine.</p>
          <br />
          <a className="b-dev__link" href="https://www.airmiles.nl/miles-en-me/" target="_blank" rel="noopener noreferrer"><p>></p>Visit Miles & Me website.</a>
        </div>
      </div>
      <div className="b-dev__container">
        <a className="b-dev__cover" href="https://occasions.audi.nl/#/" target="_blank" rel="noopener noreferrer">
        <img className="lazyload b-dev__cover-image" src={require('../static/images/menu_covers/audi_cover.png')} alt="occasions-audi" />
        </a>
        <div className="b-dev__content">
        <h4 className="b-dev__title">Audi Occasions</h4>
          <p>One of the whitelabel websites built for Pon's Automobielhandel B.V. by Dept.<br /> Followed by ŠKODA, SEAT, Volkswagen and VW Bedrijfswagens.</p>
          <p>Built with React and Next.js. Uses Typescript and Styled Components.</p>
          <br />
          <a className="b-dev__link" href="https://occasions.audi.nl/#/" target="_blank" rel="noopener noreferrer"><p>></p>Visit Audi Occasions website.</a>
        </div>
      </div>
      <div className="b-dev__container">
        <a className="b-dev__cover" href="https://booreiland.amsterdam/work/transformcity/" target="_blank" rel="noopener noreferrer">
        <img className="lazyload b-dev__cover-image" src={require('../static/images/menu_covers/transformcity_cover.png')} alt="transformcity" />
        </a>
        <div className="b-dev__content">
        <h4 className="b-dev__title">Transformcity</h4>
          <p>Toolkit for collaborative urban development brought by Booreiland for Transformcity and Gemeente Amsterdam.</p>
          <p>Built with Keystone 4 and MongoDB, with a React frontend in a Docker container.</p>
          <br />
          <a className="b-dev__link" href="https://booreiland.amsterdam/work/transformcity/" target="_blank" rel="noopener noreferrer"><p>></p>See the case at Booreiland.amsterdam.</a>
        </div>
      </div>
      <div className="b-dev__container">
        <a className="b-dev__cover" href="https://www.worldstream.com/en/" target="_blank" rel="noopener noreferrer">
        <img className="lazyload b-dev__cover-image" src={require('../static/images/menu_covers/worldstream_cover.png')} alt="worldstream" />
        </a>
        <div className="b-dev__content">
        <h4 className="b-dev__title">Worldstream</h4>
          <p>Web platform for an internet service provider by Dept.</p>
          <p>Built with Nunjucks, a JavaScript templating engine.</p>
          <br />
          <a className="b-dev__link" href="https://www.worldstream.com/en/" target="_blank" rel="noopener noreferrer"><p>></p>Visit Worldstream website.</a>
        </div>
      </div>
      <div className="b-dev__container">
        <a className="b-dev__cover" href="https://urbee.nl/" target="_blank" rel="noopener noreferrer">
        <img className="lazyload b-dev__cover-image" src={require('../static/images/menu_covers/urbee_cover.png')} alt="urbee" />
        </a>
        <div className="b-dev__content">
        <h4 className="b-dev__title">Urbee</h4>
          <p>Website for shared e-bikes by Booreiland.</p>
          <p>Built with headless CMS, modern WordPress LEMP stack; Bedrock and Trellis.</p>
          <br />
          <a className="b-dev__link" href="https://urbee.nl/" target="_blank" rel="noopener noreferrer"><p>></p>Visit the Urbee website.</a>
        </div>
      </div>
      <div className="b-dev__container">
        <a className="b-dev__cover" href="https://booreiland.amsterdam/work/thrill-seeker/" target="_blank" rel="noopener noreferrer">
        <img className="lazyload b-dev__cover-image" src={require('../static/images/menu_covers/ts_cover.png')} alt="thrillseeker" />
        </a>
        <div className="b-dev__content">
        <h4 className="b-dev__title">Thrill Seeker</h4>
          <p>WPG Uitgevers' online book wizard by Booreiland.</p>
          <p>Built with headless CMS, modern WordPress LEMP stack; Bedrock and Trellis, React.js and Next.js.</p>
          <br />
          <a className="b-dev__link" href="https://booreiland.amsterdam/work/thrill-seeker/" target="_blank" rel="noopener noreferrer"><p>></p>See the case at Booreiland.amsterdam.</a>
        </div>
      </div>
      <div className="b-dev__container">
        <a className="b-dev__cover" href="https://itunes.apple.com/nl/app/choices/id1442083415?l=en&mt=8" target="_blank" rel="noopener noreferrer">
        <img className="lazyload b-dev__cover-image" src={require('../static/images/menu_covers/csc_cover.png')} alt="csc" />
        </a>
        <div className="b-dev__content">
          <h4 className="b-dev__title">Choices Support Center</h4>
          <p>App for Treatment, Testing and Wellbeing by Booreiland.</p>
          <p>Built with React Native with Expo.</p>
          <br />
          <a className="b-dev__link" href="https://itunes.apple.com/nl/app/choices/id1442083415?l=en&mt=8" target="_blank" rel="noopener noreferrer"><p>></p>See the case in App Store.</a>
        </div>
      </div>
    </div>
  )

  return (
    <React.Fragment>
      {blocks}
    </React.Fragment>
  )
}
